import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EmailMessage, EmailMessageIgnoreList } from '../models/email-message.model';
import { GenericBaseService } from './generic-base.service';
import { UrlService } from "./url.service";

@Injectable({
  providedIn: 'root'
})

export class EmailMessageService extends GenericBaseService {

  constructor(
    protected httpClient: HttpClient,
    protected toastrService: ToastrService,
    protected url: UrlService
  ) {
    super('Email Message', httpClient, toastrService, url);
  }

  postEmailMessage(emailMessage: EmailMessage, afterPostCallback?: Function, addedMessage?: string, addedAndSendMessage?: string) {
    this.post('/email-message', this.getBody(emailMessage, EmailMessageIgnoreList))
      .subscribe(
        (postedEmailMessage: EmailMessage) => {
          if (afterPostCallback) {
            afterPostCallback();
          }

          if (postedEmailMessage.HasError) {
            this.toastrService.warning(postedEmailMessage.ErrorMessage);
            this.toastrService.success(addedMessage);
          } else {
            this.toastrService.success(addedAndSendMessage);
          }
        });
  }

  sendEmailMessage(emailMessage: EmailMessage, afterPostCallback?: Function, customMessage?: string) {
    return this.postNow('/email-message/send', this.getBody(emailMessage, EmailMessageIgnoreList), afterPostCallback, customMessage);
  }
}
